const companyActions = {
  // SAGA
  GET_COMPANIES: 'GET_COMPANIES',
  GET_COMPANY: 'GET_COMPANY',
  CREATE_OR_UPDATE_COMPANY_WATCHER: 'CREATE_OR_UPDATE_COMPANY_WATCHER',
  DELETE_COMPANY_WATCHER: 'DELETE_COMPANY_WATCHER',
  MERGE_COMPANIES_WATCHER: 'MERGE_COMPANIES_WATCHER',
  GET_COMPANIES_LIST: 'GET_COMPANIES_LIST',

  GET_COMPANY_CONTACTS: 'GET_COMPANY_CONTACTS',
  CREATE_OR_UPDATE_COMPANY_CONTACT_WATCHER: 'CREATE_OR_UPDATE_COMPANY_CONTACT_WATCHER',
  DELETE_CONTACT_WATCHER: 'DELETE_CONTACT_WATCHER',

  // REDUCER
  SET_COMPANIES: 'SET_COMPANIES',
  SET_COMPANY: 'SET_COMPANY',
  SET_COMPANIES_LIST: 'SET_COMPANIES_LIST',

  SET_USERS: 'SET_USERS',

  CREATE_COMPANY: 'CREATE_COMPANY',
  UPDATE_COMPANY: 'UPDATE_COMPANY',
  DELETE_COMPANY: 'DELETE_COMPANY',
  MERGE_COMPANIES: 'MERGE_COMPANIES',

  SET_COMPANY_CONTACTS: 'SET_COMPANY_CONTACTS',
  CREATE_CONTACT: 'CREATE_CONTACT',
  UPDATE_CONTACT: 'UPDATE_CONTACT',
  DELETE_CONTACT: 'DELETE_CONTACT',

  // SEARCH
  COMPANY_ERROR: 'COMPANY_ERROR',
  RESET_COMPANY_STATUS: 'RESET_COMPANY_STATUS',

  // Saga functions
  getCompanies: companies => ({
    type: companyActions.GET_COMPANIES,
    payload: companies,
  }),

  getCompaniesList: params => ({
    type: companyActions.GET_COMPANIES_LIST,
    payload: params,
  }),

  getCompany: companies => ({
    type: companyActions.GET_COMPANY,
    payload: companies,
  }),

  createOrUpdateCompanyWatcher: company => {
    return {
      type: companyActions.CREATE_OR_UPDATE_COMPANY_WATCHER,
      payload: company,
    };
  },

  deleteCompanyWatcher: companyId => {
    return {
      type: companyActions.DELETE_COMPANY_WATCHER,
      payload: companyId,
    };
  },

  mergeCompaniesWatcher: mergeData => {
    return {
      type: companyActions.MERGE_COMPANIES_WATCHER,
      payload: mergeData,
    };
  },

  // * Contacts
  getContacts: company => ({
    type: companyActions.GET_COMPANY_CONTACTS,
    payload: company,
  }),

  createOrUpdateCompanyContactWatcher: contact => {
    return {
      type: companyActions.CREATE_OR_UPDATE_COMPANY_CONTACT_WATCHER,
      payload: contact,
    };
  },

  deleteContactWatcher: contact => {
    return {
      type: companyActions.DELETE_CONTACT_WATCHER,
      payload: contact,
    };
  },

  // Reducer functions
  setCompanies: companies => ({
    type: companyActions.SET_COMPANIES,
    payload: companies,
  }),

  setCompaniesList: data => ({
    type: companyActions.SET_COMPANIES_LIST,
    payload: data,
  }),

  setUsers: companies => ({
    type: companyActions.SET_USERS,
    payload: companies,
  }),

  setCompany: company => ({
    type: companyActions.SET_COMPANY,
    payload: company,
  }),

  createCompany: company => {
    return {
      type: companyActions.CREATE_COMPANY,
      payload: company,
    };
  },
  updateCompany: company => {
    return {
      type: companyActions.UPDATE_COMPANY,
      payload: company,
    };
  },
  deleteCompany: companyId => {
    return {
      type: companyActions.DELETE_COMPANY,
      payload: companyId,
    };
  },
  mergeCompanies: mergeResult => {
    return {
      type: companyActions.MERGE_COMPANIES,
      payload: mergeResult,
    };
  },
  resetCompanyStatus: () => {
    return {
      type: companyActions.RESET_COMPANY_STATUS,
    };
  },

  // * Contacts
  createContact: contact => {
    return {
      type: companyActions.CREATE_CONTACT,
      payload: contact,
    };
  },
  updateContact: contact => {
    return {
      type: companyActions.UPDATE_CONTACT,
      payload: contact,
    };
  },
  deleteContact: contact => {
    return {
      type: companyActions.DELETE_CONTACT,
      payload: contact,
    };
  },

  // * Contacts
  setContacts: contacts => ({
    type: companyActions.SET_COMPANY_CONTACTS,
    payload: contacts,
  }),
};

export default companyActions;
